<template>
	<div class="back">
		<!-- backimg -->
		<a href="javascript:void(0);"><img @click="backhome" class="backimg"
				src="../../assets/images/backhome.png" /></a>
	</div>
</template>

<script>
	export default {
		name: 'back',
		methods: {
			backhome() {
				this.$router.replace("/home")
			}
		}
	}
</script>

<style scoped>
	.back .backimg {
		position: absolute;
		width: 4rem;
		height: 4rem;
		z-index: 99;
		right: 6rem;
		top: 1rem;
	}
</style>
